import PropTypes from 'prop-types'
import React from 'react'
import { Card, CardHeader, Table, CardFooter } from 'reactstrap'
import RedirectButton from 'components/atoms/redirect-button'

const propTypes    = {
  customerBank: PropTypes.shape({
    name           : PropTypes.string,
    holder_name    : PropTypes.string,
    account_number : PropTypes.string,
    branch         : PropTypes.string
  }),
  id: PropTypes.number
}
const defaultProps = {
  customerBank: {
    name           : '',
    holder_name    : '',
    account_number : '',
    branch         : ''
  }
}

/**
 * @param {object} customerBank - refund customer bank detail
 * @param {number} id - customer refund - id
 */
const CustomerRefundCustomerBankCard = ({
  customerBank,
  id
}) => (
  <Card>
    <CardHeader>
      Bank Detail
    </CardHeader>
    <Table hover>
      <tbody>
        <tr>
          <th scope='row'>Bank Name</th>
          <td>{ customerBank.name }</td>
        </tr>
        <tr>
          <th scope='row'>Holder Name</th>
          <td className='text-wrap'>{ customerBank.holder_name }</td>
        </tr>
        <tr>
          <th scope='row'>Account No</th>
          <td>{ customerBank.account_number }</td>
        </tr>
        <tr>
          <th scope='row'>Branch</th>
          <td>{ customerBank.branch }</td>
        </tr>
      </tbody>
    </Table>
    <CardFooter className='text-right'>
      <RedirectButton
        color='warning'
        text={ 'Update' }
        path={ `/app/customer-service/refunds/${id}/customer-bank-detail` }
        state={ customerBank }
      />
    </CardFooter>
  </Card>
)

CustomerRefundCustomerBankCard.propTypes    = propTypes
CustomerRefundCustomerBankCard.defaultProps = defaultProps

export default CustomerRefundCustomerBankCard